module.exports = "https://cdn.hellotech.com/client-assets/phones_and_tablets_mobile_a33d791fd7f18fb2b11f000a1650be43.png";